var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isDataLoaded)?_c('div',{staticClass:"page"},[_c('div',{staticClass:"b1",domProps:{"innerHTML":_vm._s(_vm.detail.contents)}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }